// removed by extract-text-webpack-plugin
module.exports = {"marginTop":"styles__marginTop___133uh","select":"styles__select___11_G1","button":"styles__button___1vxrt","selectMult":"styles__selectMult___3Y8uW","containerButton":"styles__containerButton___3u1L6"};


//////////////////
// WEBPACK FOOTER
// ./src/scenes/DetailingPosPreControle/styles.css
// module id = 2704
// module chunks = 0